<template>
  <div class="lib__form__main">
    <validation-observer ref="validator" slim tag="div" class="lib__form__main__content">
      <header class="lib__form__main__header">
        <h2 class="lib__h2">{{ $t('new-connection-cmh.files-step.wouldYouLikeToUploadFiles') }}</h2>
        <i18n path="new-connection-cmh.files-step.filesWhichCanBeProvided" tag="p">
          <template #plans>
            <span class="lib__text-weight-600">{{ $t('new-connection-cmh.files-step.plans') }}</span>
          </template>
          <template #photos>
            <span class="lib__text-weight-600">{{ $t('new-connection-cmh.files-step.photos') }}</span>
          </template>
        </i18n>
        <p>{{ $t('new-connection-cmh.files-step.sharingFilesAllowOresToSpeedUpTheProcess') }}</p>
      </header>

      <validation-provider rules="required" slim v-slot="state">
        <div class="lib__field">
          <div class="lib__tiles">
            <tile-radio group="tile-radio" :label="$t('common.yes')" :item="true" v-model="showInputFile" />
            <tile-radio group="tile-radio" :label="$t('common.no')" :item="false" v-model="showInputFile" />
          </div>
          <error-message :error="state.errors[0]"></error-message>
        </div>
      </validation-provider>

      <more-information v-if="showInputFile" :borderColor="'#34B4E4'" :textColor="'#0096CE'"
        :information="$t('new-connection-cmh.files-step.acceptedFormatInfo')" />

      <validation-provider :rules="{ no_errored_file: true }">
        <works-input-file v-if="showInputFile" :label="''" :requestId="requestId" :filesInfo="fileInfo"
          accept="jpg|jpeg|png|gif|pdf|doc|docx|xls|xlsx|zip|eml|msg|dwg" directory="new-connection"
          :value="fileInError"></works-input-file>
        <input type="hidden" :value="fileInError" />
      </validation-provider>
      <feedback v-if="fileInError && showInputFile" level="danger" simple icon>
        <p>{{ $t('new-connection-cmh.files-step.fileInError') }}</p>
      </feedback>
    </validation-observer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import WorksInputFile from '@/components/inputs/Files/WorksInputFile.vue'
import { State, Mutation } from 'vuex-class'
import { FileInfo } from '@ores/vue-library'
import MoreInformation from '@/components/display/MoreInformation.vue'
import { CmhFilesState } from '@/store/new-connection-cmh/cmh-files/types'
import { helper } from '@/services'
import { pixelFacebookService } from '@ores/vue-library'
import { extend } from 'vee-validate'
import { i18n } from '@/i18n'

@Component({
  components: {
    MoreInformation,
    WorksInputFile
  },
  name: 'cmh-files-step'
})
export default class CmhFilesStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'newConnectionCmh' })
  public requestId!: string

  @State('fileInfo', { namespace: 'newConnectionCmh/cmhFiles' })
  public stateFileInfo!: FileInfo[]

  @State('showInputFile', { namespace: 'newConnectionCmh/cmhFiles' })
  public stateShowInputFile!: boolean | null

  public fileInfo: FileInfo[] = []

  public showInputFile: boolean | null = null;
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'newConnectionCmh/cmhFiles' })
  public store!: (index: CmhFilesState) => void
  //#endregion

  //#region [Computed]
  public get fileInError(): boolean {
    return (
      this.fileInfo.some((v) => v.error !== null)
    )
  }
  //#endregion

  //#region [Method]
  public mounted(): void {
    extend('no_errored_file', {
      // If no errors in files or file input is not showed
      validate: (value) => { return !value || !this.showInputFile! }
    })
    pixelFacebookService.trackViewContent({
      content_ids: ['CmhForm'],
      content_name: 'Files Step',
      content_type: 'product'
    })
    if (this.stateFileInfo) {
      this.fileInfo = helper.clone(this.stateFileInfo)
    }
    this.showInputFile = helper.clone(this.stateShowInputFile)
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean | void> {
    this.store({
      fileInfo: this.fileInfo.filter((a) => a.error === null),
      showInputFile: this.showInputFile
    })
    this.$appInsights.trackEvent('WR_NCCMH_Step7_Validated', { Segment: 'WR_NCCMH', WebRef: this.requestId })
  }
  //#endregion
}
</script>

<style>
div.cmh-modal-layout div.lib__dialogs__box {
  box-shadow: 0 8px 16px 0 rgba(12, 0, 51, 0.1);
}

div.cmh-modal-layout div.lib__dialogs.lib__dialogs--open {
  opacity: 0.95;
  background-color: #f9f8f8;
}

@media screen and (max-width: 576px) {
  div.meter-example-modal div.lib__dialogs__box {
    width: 90%;
    height: auto;
  }

  div.meter-example-modal div.lib__dialogs__content {
    padding: 0px;
  }

  div.building-example-modal div.lib__dialogs__box {
    width: 90%;
    height: auto;
  }

  div.building-example-modal div.lib__dialogs__content {
    padding: 0px;
  }
}
</style>

<style scoped>
.no-padding-right {
  padding-right: 0px;
}

.col-indexer-width {
  max-width: 26px;
}
</style>